export enum BookingTypeEnum {
  UNDEFINED = 0,
  BOOKING = 1,
  UNION = 2,
  BLOCKED = 3,
  BLOCKED_MAINTENANCE = 4,
  BLOCKED_CONSTRUCTION = 5,
  BLOCKED_PREPARATION = 6,
  BLOCKED_OWN_USAGE = 7,
  BLOCKED_HOLIDAY = 8,
  BLOCKED_VACATION = 9,
  BLOCKED_CORONA = 10,
  FIXED = 11,
  BLOCKED_CULTURE_AND_ACTIVITIES = 12,
  BLOCKED_INTERNAL_MEETING = 13,
  BLOCKED_OPERATIONAL_CLOSURE = 14,
  BLOCKED_HOLIDAY_CLOSURE = 15,
}

export type BookingType = keyof typeof BookingTypeEnum;

/**
 * The booking type's name, or '' when the API sends one it has no name for: a type added later is
 * serialized as its number (e.g. 16), and a screen must show the booking anyway.
 */
export function bookingTypeName(type: unknown): string {
  return typeof type === 'string' ? type : '';
}

/** The row's CSS class for its booking type (`booking-type-blocked` …); `booking-type-` for an unknown one. */
export function bookingTypeClass(type: unknown): string {
  return 'booking-type-' + bookingTypeName(type).toLowerCase();
}
